import { render } from "./uberall-search-interface.vue?vue&type=template&id=3932c512"
import script from "./uberall-search-interface.vue?vue&type=script&lang=js"
export * from "./uberall-search-interface.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__